"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingSize = void 0;
/**
 * {@docCategory Rating}
 */
var RatingSize;
(function (RatingSize) {
    RatingSize[RatingSize["Small"] = 0] = "Small";
    RatingSize[RatingSize["Large"] = 1] = "Large";
})(RatingSize || (exports.RatingSize = RatingSize = {}));
//# sourceMappingURL=Rating.types.js.map